<template>
  <div class="container">
    <div class="main">
      <div class="flexHeader">
        <div class="fixbox">
          <van-nav-bar
            :title="lang.editProSub"
            left-arrow
            @click-left="prev"
          />
        </div>
        <div class="flexHeader_tit">
          <div class="allcheck">
            <van-checkbox
              v-model="allChecked"
              checked-color="#ee0a24"
            >
              {{ lang.allSub }}
            </van-checkbox>
          </div>
          <div class="funbut">
            <span @click="addfavSub">
              <img
                v-if="selSubData && selSubData.length"
                src="../assets/sub_fav.png"
                :alt="lang.noInfo"
                class="sub_col"
              >
              <img
                v-else
                src="../assets/sub_fav_dis.png"
                :alt="lang.noInfo"
                class="sub_col"
              >
              <i :class="['funbut_font', { disfont: !(selSubData && selSubData.length) }]">{{ lang.addfavSub }}</i>
            </span>
            <span
              class="spanmar"
              @click="editSub"
            >
              <img
                v-if="selSubData && selSubData.length"
                src="../assets/subediticon.png"
                :alt="lang.noInfo"
                class="sub_coledit"
              >
              <img
                v-else
                src="../assets/subedit_dis.png"
                :alt="lang.noInfo"
                class="sub_coledit"
              >
              <i :class="['funbut_font', { disfont: !(selSubData && selSubData.length) }]">{{ lang.subEdit }}</i>
            </span>
            <span
              class="spanmar"
              @click="delSub"
            >
              <img
                v-if="selSubData && selSubData.length"
                src="../assets/sub-del.png"
                :alt="lang.noInfo"
                class="sub_coledit"
              >
              <img
                v-else
                src="../assets/sub_del_dis.png"
                :alt="lang.noInfo"
                class="sub_coledit"
              >
              <i :class="['funbut_font', { disfont: !(selSubData && selSubData.length) }]">{{ lang.subDel }}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="flexCont">
        <!-- <van-loading v-show="loadedata" /> -->
        <div class="draggable">
          <van-checkbox-group v-model="selSubData">
            <draggable
              v-model="edata"
              chosen-class="chosen"
              handle=".dragimg"
              :disabled="draggableStart"
              @end="tagEnd"
            >
              <transition-group>
                <div
                  v-for="(item, index) in edata"
                  :key="index"
                  class="dragBox"
                >
                  <div class="flexcheck">
                    <span class="checktit">
                      <van-checkbox
                        checked-color="#ee0a24"
                        :name="item.subscribeID"
                      >{{ item.title }}</van-checkbox>
                    </span>
                    <span class="dragimg">
                      <img
                        v-if="item.isDefault"
                        src="../assets/sub_fav_dis.png"
                        :alt="lang.noInfo"
                        class="sub_col sub-colr"
                      >
                      <img
                        src="../assets/subDrag.png"
                        :alt="lang.noInfo"
                        class="sub_col"
                      >
                    </span>
                  </div>
                  <div class="conItemBox">
                    <!-- <div> -->
                    <!-- 租售/地址1-2-3/业主或代理/楼盘类型住宅?/价格/面积/2房/年10-23年 -->
                    {{ item.searchPropertyRequest.rentalType == 1 ? lang.sale + '/' : lang.rent + '/' }}
                    {{ subscribeSource(item.searchPropertyRequest.propertySourceList) }}{{ subscribeRegion(item) }}
                    {{ priceRangeC(item) }}
                    {{ item.propertyCategory ? subscribeCategory(item.searchPropertyRequest.propertyCategory, item.searchPropertyRequest.subCategory) : '' }}
                    {{ subscribeArea(item) }}{{ subscribeRoomNum(item.searchPropertyRequest.roomNumbers) }}
                    {{ subscribeUnitFloor(item.searchPropertyRequest.unitFloors) }}
                    {{ subBuildAge(item.buildingAge) }}
                    <!-- </div> -->
                  </div>
                </div>
              </transition-group>
            </draggable>
          </van-checkbox-group>
        </div>
      </div>
      <div class="flexfooter">
        <div class="footer_con">
          <div class="footer_tit">
            {{ lang.pushSet }}
          </div>
          <van-cell
            :title="lang.notify"
            is-link
            @click="showPushSet = true"
          >
            <span v-if="pushWeeks && pushWeeks.length > 0">
              {{ selNotiEcho(pushWeeks, pushNotification) }}
            </span>
          </van-cell>
          <van-popup
            v-model="showPushSet"
            :close-on-click-overlay="false"
            position="bottom"
          >
            <div class="footer_tit footer_titpop">
              {{ lang.notify }}
            </div>
            <ul>
              <van-checkbox-group v-model="pushWeeks">
                <li
                  v-for="item in pushNotification"
                  :key="item.dictionaryValue"
                  :class="['footer_flexli', { selected: pushWeeks.indexOf(item.dictionaryValue) != -1 }]"
                  @click="selMethli(item.dictionaryValue)"
                >
                  <span>{{ item.dictionaryNameWithCulture }}</span>
                  <span>
                    <van-checkbox
                      checked-color="#ED1818"
                      :name="item.dictionaryValue"
                    />
                  </span>
                </li>
              </van-checkbox-group>
            </ul>
            <template>
              <van-button
                class="footer_btn canBtn"
                type="info"
                @click="cancelSel('pushWeeks')"
              >
                {{ lang.cancelAll }}
              </van-button>
              <van-button
                class="footer_btn"
                type="danger"
                @click="confirmSel('showPushSet')"
              >
                {{ lang.confirm }}
              </van-button>
            </template>
          </van-popup>
          <van-cell
            :title="lang.pushTime"
            is-link
            @click="showPushTime = true"
          >
            <span v-if="selTimeiResult">{{ selEcho(selTimeiResult, pushTime) }}</span>
          </van-cell>
          <van-popup
            v-model="showPushTime"
            :close-on-click-overlay="false"
            position="bottom"
          >
            <div class="footer_tit footer_titpop">
              {{ lang.pushTime }}
            </div>
            <ul>
              <van-radio-group v-model="selTimeiResult">
                <li
                  v-for="item in pushTime"
                  :key="item.dictionaryValue"
                  :class="['footer_flexli', { selected: selTimeiResult && selTimeiResult.indexOf(item.dictionaryValue) != -1 }]"
                  @click="selTimeMethli('selTimeiResult', item.dictionaryValue)"
                >
                  <span>{{ item.dictionaryNameWithCulture }}</span>
                  <span>
                    <van-radio
                      checked-color="#ED1818"
                      :name="item.dictionaryValue"
                    />
                  </span>
                </li>
              </van-radio-group>
            </ul>
            <template>
              <van-button
                class="footer_btn canBtn"
                type="info"
                @click="cancelSel('selTimeiResult')"
              >
                {{ lang.cancelAll }}
              </van-button>
              <van-button
                class="footer_btn"
                type="danger"
                @click="confirmSel('showPushTime')"
              >
                {{ lang.confirm }}
              </van-button>
            </template>
          </van-popup>
          <van-cell
            class="cell_footer"
            :title="lang.pushWay"
            is-link
            @click="showPushMethod = true"
          >
            <span v-if="selMethResult">{{ selEcho(selMethResult, pushMethod) }}</span>
          </van-cell>
          <van-popup
            v-model="showPushMethod"
            :close-on-click-overlay="false"
            position="bottom"
          >
            <div class="footer_tit footer_titpop">
              {{ lang.pushWay }}
            </div>
            <ul>
              <van-radio-group v-model="selMethResult">
                <li
                  v-for="item in pushMethod"
                  :key="item.dictionaryValue"
                  :class="['footer_flexli', { selected: selMethResult && selMethResult.indexOf(item.dictionaryValue) != -1 }]"
                  @click="selTimeMethli('selMethResult', item.dictionaryValue)"
                >
                  <span>{{ item.dictionaryNameWithCulture }}</span>
                  <span>
                    <van-radio
                      checked-color="#ED1818"
                      :name="item.dictionaryValue"
                    />
                  </span>
                </li>
              </van-radio-group>
            </ul>
            <template>
              <van-button
                class="footer_btn canBtn"
                type="info"
                @click="cancelSel('selMethResult')"
              >
                {{ lang.cancelAll }}
              </van-button>
              <van-button
                class="footer_btn"
                type="danger"
                @click="confirmSel('showPushMethod')"
              >
                {{ lang.confirm }}
              </van-button>
            </template>
          </van-popup>
        </div>
      </div>
      <van-dialog
        v-model="dialogShow"
        class="favdialog"
        :confirm-button-text="lang.okCon"
      >
        <p class="keyWord">
          {{ showFavSubDialog ? lang.editSub : lang.favSub }}
        </p>
      </van-dialog>
      <van-dialog
        v-model="dialogDelShow"
        class="favdialog"
        :confirm-button-text="lang.keyCon"
        :cancel-button-text="lang.canBtn"
        show-cancel-button
        @confirm="gotodel"
      >
        <p class="keyWord">
          {{ selSubData.length > 1 ? lang.delSubs : lang.delsub + delItem + lang.delsubBot }}
        </p>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import lang from './../../common/language/subscribe';
import tool from '../../common/js/tools.js';
const _conf = require('../../common/js/_conf');

export default {
  components: {},
  data() {
    return {
      loadedata: false,
      dialogDelShow: false,
      delItem: '',
      showFavSubDialog: false,
      dialogShow: false,
      selSubData: [],
      showPushSet: false,
      showPushTime: false,
      showPushMethod: false,
      lang,
      draggableStart: false,
      showEdata: false,
      selectedSubs: [],
      edata: [],
      dic: [],
      pushTime: [], //推送时间 早中晚
      pushNotification: [], //推送提醒
      pushMethod: [], //推送方式
      pushWeeks: [], //弹出框选中值
      selTimeiResult: '',
      selMethResult: '',
      gscopelist: [],
      rommNumlang: [],
      unitFloors: [],
      buildingAge: [],
      propertyCateLang: [],
      newEstateArea: [],
      rentPrice: [],
      salePrice: [],
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
    };
  },
  computed: {
    allChecked: {
      set(value) {
        // 作用：获取全选框的状态(true/false)，然后修改选项框状态
        if (value) {
          this.selSubData = this.edata.map((obj) => obj.subscribeID);
        } else {
          this.selSubData = [];
        }
      },
      get() {
        // 作用：监听选项框状态 -> 全选状态
        return this.selSubData.length == this.edata.length && this.edata.length != 0 ? true : false;
      },
    },
    selNotiEcho() {
      return function (type, arrayList) {
        let result = type.length === arrayList.length && type.every((value) => arrayList.some((item) => item.dictionaryValue === value));
        if (result) {
          return lang.allweek;
        } 
          let matchedNames = type
            .map((value) => arrayList.find((item) => item.dictionaryValue === value))
            .filter((item) => item)
            .map((item) => item.dictionaryNameWithCulture)
            .slice(0, 3)
            .join('、');
          if (type.length > 3) {
            matchedNames += '...';
          }
          return matchedNames;
        
      };
    },
    selEcho() {
      return function (type, arrayList) {
        let result = arrayList.find((item) => item.dictionaryValue == type);
        let matchedCulture = result ? result.dictionaryNameWithCulture : null;
        return matchedCulture;
      };
    },
    // priceRangeC() {
    //   return function (val) {
  
    //   };
    // },
    subBuildAge() {
      return function (val) {
        if (val && val.length) {
          let result = this.buildingAge.find((item) => item.dictionaryValue == val);
          let matchedCulture = result ? result.dictionaryNameWithCulture : '';
          return matchedCulture;
        }
      };
    },
    subscribeUnitFloor() {
      return function (val) {
        if (val && val.length) {
          let string = '';
          for (let i = 0; i < this.unitFloors.length; i++) {
            if (val.includes(parseInt(this.unitFloors[i].dictionaryValue))) {
              string += this.unitFloors[i].dictionaryNameWithCulture + '-';
            }
          }
          string = string.slice(0, -1); // 移除最后一个连接符 '-'
          return string + '/';
        } 
          return '';
        
      };
    },
    subscribeRoomNum() {
      return function (val) {
        if (val && val.length) {
          let string = '';
          for (let i = 0; i < this.rommNumlang.length; i++) {
            if (val.includes(parseInt(this.rommNumlang[i].dictionaryValue))) {
              string += this.rommNumlang[i].dictionaryNameWithCulture + '-';
            }
          }
          string = string.slice(0, -1);
          return string + '/';
        } 
          return '';
        
      };
    },
    subscribeSource() {
      return function (val) {
        if (val && val.length > 1) {
          return this.lang.landlord + '-' + this.lang.agency + '/';
        } else if (val && val.length == 1) {
          return val[0] == 1 ? this.lang.landlord + '/' : this.lang.agency + '/';
        } 
          return '';
        
      };
    },
    subscribeRegion() {
      return function (val) {
        // // 首先遍历region
        let regionstring = '';
        let zoneString = '';
        let gscopeString = '';
        let gscopedArray = [];

        for (let i = 0; i < this.gscopelist.length; i++) {
          let item = this.gscopelist[i];
          if (item.gscopeCode == val.regionCode) {
            let itemChidren = item.children;
            regionstring = item.gscopeNameWithCulture;
            if (val.zoneCode && val.zoneCode.length) {
              for (let j = 0; j < val.zoneCode.length; j++) {
                let code = val.zoneCode[j];
                let matchingObject = itemChidren.find((obj) => obj.gscopeCode == code);
                if (matchingObject) {
                  gscopedArray.push(...matchingObject.children);
                  zoneString += matchingObject.gscopeNameWithCulture;
                  if (j < val.zoneCode.length - 1) {
                    zoneString += '、';
                  }
                }
              }
              if (val.gscopeCode && val.gscopeCode.length) {
                for (let z = 0; z < val.gscopeCode.length; z++) {
                  let matchingObject = gscopedArray.find((obj) => obj.gscopeCode == val.gscopeCode[z]);
                  if (matchingObject) {
                    gscopeString += matchingObject.gscopeNameWithCulture;
                    if (z < val.gscopeCode.length - 1) {
                      gscopeString += '、';
                    }
                  }
                }
              }
            }
          }
        }
        if (regionstring.length && zoneString.length && gscopeString.length) {
          return regionstring + '-' + zoneString + '-' + gscopeString + '/';
        } else if (regionstring.length && zoneString.length) {
          return regionstring + '-' + zoneString + '/';
        } else if (regionstring.length) {
          return regionstring + '/';
        } 
          return '';
        
      };
    },
    subscribeArea() {
      return function (val) {
        if (val.areaRange && val.areaRange.length) {
          let langstring = val.areaType == 'BuildingArea' ? this.lang.bRange : this.lang.sRange;
          let result = this.newEstateArea.find((item) => item.dictionaryValue == val.areaRange);
          if (result) {
            return langstring + result.dictionaryNameWithCulture + '/';
          } 
            return langstring + val.areaRange + '/';
          
        } 
          let maxBuildingAreaa = ''
          let maxSaleableArea = ''
          if (val.searchPropertyRequest.maxBuildingArea || val.searchPropertyRequest.minBuildingArea) {
            maxBuildingAreaa = val.searchPropertyRequest.maxBuildingArea ? val.searchPropertyRequest.maxBuildingArea +' '+ this.lang.low: val.searchPropertyRequest.minBuildingArea + this.lang.up;
            return this.lang.bRange + maxBuildingAreaa + '/';
          } else if (val.searchPropertyRequest.maxSaleableArea || val.searchPropertyRequest.minSaleableArea) {
            maxSaleableArea = val.searchPropertyRequest.maxSaleableArea ? val.searchPropertyRequest.maxSaleableArea + ' '+this.lang.low: val.searchPropertyRequest.minSaleableArea + this.lang.up;
            return this.lang.sRange + maxSaleableArea + '/';
          }
        
      };
    },
    subscribeCategory() {
      return function (val, valchilren) {
        let properstring = '';
        let subString = '';
        if (val && val.length) {
          // console.log("val[0--0]",val[0])
          for (let i = 0; i < this.propertyCateLang.length; i++) {
            let item = this.propertyCateLang[i];
            if (item.dictionaryValue == val[0]) {
              let itemChidren = item.children;
              properstring = item.dictionaryNameWithCulture;
              if (valchilren && valchilren.length) {
                for (let j = 0; j < valchilren.length; j++) {
                  let subCategory = valchilren[j];
                  let matchingObject = itemChidren.find((obj) => obj.dictionaryValue == subCategory);
                  if (matchingObject) {
                    subString += matchingObject.dictionaryNameWithCulture;
                    if (j < valchilren.length - 1) {
                      subString += '、';
                    }
                  }
                }
              }
            }
          }
        }
        if (properstring.length && subString.length) {
          return properstring + '-' + subString + '/';
        } else if (properstring.length) {
          return properstring + '/';
        } 
          return '';
        
      };
    },
  },
  created() {
    this.getSubCon();
    this.GetGscope();
    this.getDictionary();
    this.GetPushInfo();
  },
  methods: {
    priceRangeC(val){
        if (val.propertyType == 2) {
          if(val.priceRange && val.priceRange.length){
            let result = this.rentPrice.find((item) => item.dictionaryValue == val.priceRange);
            if (result) {
              return result.dictionaryNameWithCulture + '/';
            } 
              return val.priceRange + this.lang.yuan + '/';
            
          }else if(val.searchPropertyRequest.maxRentPrice || val.searchPropertyRequest.minRentPrice){
            let maxrentPrice =''
            if(this.language === 'en-us'){
              maxrentPrice = val.searchPropertyRequest.maxRentPrice ? this.lang.low +val.searchPropertyRequest.maxRentPrice+ this.lang.yuan : val.searchPropertyRequest.minRentPrice+ this.lang.yuan+this.lang.up ;

              }else{
                maxrentPrice = val.searchPropertyRequest.maxRentPrice ? val.searchPropertyRequest.maxRentPrice+ this.lang.yuan+this.lang.low  : val.searchPropertyRequest.minRentPrice+ this.lang.yuan+this.lang.up;

              }
            return maxrentPrice+'/'
          }
            return ''
          
        } 
          if(val.priceRange && val.priceRange.length){
            let result = this.salePrice.find((item) => item.dictionaryValue == val.priceRange);
            if (result) {
              return result.dictionaryNameWithCulture + '/';
            }
              let [min, max] = val.priceRange.split('-');
              min = parseInt(min);
              max = parseInt(max);
              let numleft = '';
              let numright = '';
              let right = '';
              if (this.language === 'en-us') {
                // min >= 100000000 ? min / 1000000 :
                // max >= 100000000 ? max / 1000000 :
                numleft =  min / 1000;
                numright =  max / 1000;
              } else {
                numleft = min >= 10000 ? min / 10000 : min;
                numright = max >= 10000 ? max / 10000 : max;
              }
              if ((String(numleft)).indexOf('.') !== -1) {
                numleft = numleft.toFixed(2);
                numleft = parseFloat(numleft);
              }
              if ((String(numright)).indexOf('.') !== -1) {
                numright = numright.toFixed(2);
                numright = parseFloat(numright);
              }
              // 單位
              if (this.language === 'zh-cn') {
                right = max >= 100000 ? '万' : '';
              } else if (this.language === 'en-us') {
                // max >= 100000000 ? 'M' : 
                right = 'K';
              } else {
                right = max >= 100000 ? '萬' : '';
              }
              return numleft + '-' + numright + right + '/';
            
          }
            if(val.searchPropertyRequest.maxSalePrice || val.searchPropertyRequest.minSalePrice){           
            // 只有单边售价
            let maxsalePrice = ''
            let maxString = ''
            let numright = '';
            let right = '';

            maxsalePrice = val.searchPropertyRequest.maxSalePrice ? val.searchPropertyRequest.maxSalePrice  : val.searchPropertyRequest.minSalePrice ;
            maxString = val.searchPropertyRequest.maxSalePrice ?this.lang.low:this.lang.up
            if (this.language === 'en-us') {
              // maxsalePrice >= 100000000 ? maxsalePrice / 1000000 :
                numright =  maxsalePrice / 1000;
              } else {
                numright = maxsalePrice >= 10000 ? maxsalePrice / 10000 : maxsalePrice;
              }
              if ((String(numright)).indexOf('.') !== -1) {
                numright = numright.toFixed(2);
                numright = parseFloat(numright);
              }
              if (this.language === 'zh-cn') {
                right = maxsalePrice >= 100000 ? '万' : '';
              } else if (this.language === 'en-us') {
                // maxsalePrice >= 100000000 ? 'M' : 
                right = 'K';
              } else {
                right = maxsalePrice >= 100000 ? '萬' : '';
              }
              if(this.language === 'en-us' && maxString == 'Below '){
                return numright?maxString+numright + right + '/':''
              }
                return numright?numright + right + maxString+'/':''
              
            }
              return ''
            
          
        
    },
    selTimeMethli(type, val) {
      if (this[type].includes(val)) {
        this[type] = '';
      } else {
        this[type] = val;
      }
    },
    selMethli(val) {
      if (this.pushWeeks.includes(val)) {
        this.pushWeeks = this.pushWeeks.filter((item) => item !== val);
      } else {
        this.pushWeeks.push(val);
      }
    },
    addfavSub() {
      if (this.selSubData.length > 1) {
        this.showFavSubDialog = false;
        this.dialogShow = true;
      } else if (this.selSubData.length == 1) {
        let c = false;
        c = this.edata.filter((obj) => this.selSubData.includes(parseInt(obj.subscribeID))).map((obj) => (obj.isDefault ? false : true))[0];
        this.axios.post(this.pub.getApi().UpdateUserSubscribeDefault + `?subscribeID=${parseInt(this.selSubData[0])}&isDefault=${c}`).then((res) => {
          if (res.data.result) {
            this.getSubCon();
          }
        });
      }
    },
    // 编辑订阅
    editSub() {
      if (!(this.selSubData && this.selSubData.length)) {return;}

      if (this.selSubData.length > 1) {
        this.dialogShow = true;
        this.showFavSubDialog = true;
      } else {
        //跳转订阅页面
        const base = _conf.env_type == 4 ? 'https://sim.house730.com' : _conf.env_type == 3 ? 'https://www.house730.com' : 'https://uat.house730.com.cn';
        const type = this.language === 'zh-hk' ? '' : this.language + '/';
        location.href = `${base}/${type}subscribe/${this.selSubData[0]}`;
      }
    },
    // 删除订阅
    delSub() {
      if (!(this.selSubData && this.selSubData.length)) {return;}
      this.dialogDelShow = true;
      this.delItem = this.edata
        .filter((obj) => this.selSubData.includes(parseInt(obj.subscribeID)))
        .map((obj) => obj.title)
        .join(', ');
    },
    gotodel() {
      this.axios
        .post(this.pub.getApi().DeleteUserSubscribe, {
          ids: this.selSubData,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.selSubData= []
            this.getSubCon();
          }
        });
    },
    confirmSel(type) {
      if (this.pushWeeks.length > 0) {
        this.pushWeeks.sort((a, b) => a - b);
      }
      let data = {
        pushTime: this.selTimeiResult,
        pushWeeks: this.pushWeeks.join(),
        pushMethod: this.selMethResult,
      };
      for (let key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }
      if (Object.keys(data).length === 0) {
        data = null;
      }
      this.axios.post(this.pub.getApi().UpdateUserSubscribePushInfo, data).then((res) => {
        this.GetPushInfo(type);
        this[type] = false;
      });
    },
    cancelSel(type) {
      if (type == 'pushWeeks') {
        this[type] = [];
        // this.showPushSet = false;
      } else {
        this[type] = '';
        // type == 'selMethResult' ? (this.showPushMethod = false) : (this.showPushTime = false);
      }
      // this.GetPushInfo(type)
    },
    GetPushInfo() {
      this.axios.get(this.pub.getApi().GetUserSubscribePushInfo).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          this.selTimeiResult = String(res.data.result.pushTime);
          this.selMethResult = String(res.data.result.pushMethod);
          this.pushWeeks = res.data.result.pushWeeks && res.data.result.pushWeeks.length ? res.data.result.pushWeeks.split(',').map(String) : [];
        }
      });
    },
    getDictionary() {
      this.pub.getDictionary().then((res) => {
        this.pushTime = [...res.PushTime.children];
        this.pushNotification = [...res.PushNotification.children[res.PushNotification.children.length - 1].children];
        this.pushMethod = [...res.PushMethod.children];
        this.rommNumlang = [...res.RoomNumber.children];
        this.unitFloors = [...res.UnitFloor.children];
        this.buildingAge = [...res.BuildingAge.children];
        this.rentPrice = [...res.RentPrice.children];
        this.salePrice = [...res.SalePrice.children];
        this.propertyCateLang = [...res.PropertyCategory.children];
        this.newEstateArea = [...res.NewEstateArea.children];
      });
    },
    GetGscope() {
      this.axios.get(this.pub.getApi().GetGscope).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          this.gscopelist = res.data.result;
        }
      });
    },
    prev() {
      this.$router.go(-1);
    },
    tagEnd() {
      let deltarget = [];
      deltarget = this.edata.map((obj) => parseInt(obj.subscribeID));
      this.axios
        .post(this.pub.getApi().UpdateUserSubscribeSequence, {
          ids: deltarget,
        })
        .then((res) => {
          if (res.data.code == 0) {
            console.log('拓转结束', this.selectedSubs);
          }
        });
    },
    getSubCon() {
      // this.loadedata = true
      this.axios.get(this.pub.getApi().GetUserSubscribesV2).then((res) => {
        if (res.data.code === 0) {
          // this.loadedata = false
          this.edata = res.data.result;
          this.showEdata = true;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
//   .chosen {
//        border: solid 1px #3089dc !important;
//    }
/deep/.van-button--default {
  color: #3391ff;
}
/deep/.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #3391ff;
}
/deep/ .van-dialog {
  border-radius: 12px;
}
::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}
/deep/.favdialog .van-dialog__content {
  height: 116px;
  line-height: 116px;
  color: #000000;
  border-bottom: 1px solid #dddddd;
}
.keyWord {
  height: 116px;
  display: flex;
  line-height: 28px;
  flex-direction: column;
  justify-content: center;
}
.container {
  // padding: 0 16px;
  background-color: #f9f9f9;
}
/deep/.dragBox .van-checkbox__icon--round .van-icon {
  border-radius: 0% !important;
  border: 0.5px solid #383838;
  width: 18px;
  height: 18px;
}
/deep/.allcheck .van-checkbox__icon--round .van-icon {
  border-radius: 0% !important;
  border: 0.5px solid #383838;
  width: 18px;
  height: 18px;
}
.main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .flexCont {
    flex: 1;
    overflow-y: scroll;
    position: relative;
    overflow-x: hidden;
  }
  .flexHeader {
    height: 93px;
    .flexHeader_tit {
      padding: 0 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 45px;
      .allcheck .funbut {
        margin-top: 10px;
        display: inline-block;
      }
      .funbut {
        span {
          font-size: 14px;
        }
        .spanmar {
          margin-left: 14px;
        }
        .funbut_font {
          margin-left: 6px;
          color: #333;
        }
        .disfont {
          color: #999999;
        }
        .sub_col {
          width: 17px;
          height: 17px;
        }

        .sub_coledit {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
  .flexfooter {
    background: #fff;
    .footer_con {
      text-align: left;
      .cell_footer .van-cell__value {
        font-size: 13px;
      }
      .footer_tit {
        font-size: 16px;
        font-weight: 700;
        color: #333333;
        margin: 0 16px;
        border-bottom: 1px solid #ebedf0;
        line-height: 42px;
      }
      .footer_flexli {
        color: #333333;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        line-height: 45px;
      }
      .selected {
        background: #f4f8fb;
        color: #ed1c24;
      }
      .footer_titpop {
        font-size: 20px;
        border-bottom: 0;
        line-height: 62px;
      }
      .footer_btn {
        width: 50%;
        margin: 0;
        height: 45px;
      }
      .canBtn {
        background: #eeeeee;
        color: #999999;
        font-size: 14px;
        border: none;
      }
      /deep/.van-checkbox__icon .van-icon {
        border: none !important;
      }
      /deep/.van-radio__icon .van-icon {
        border: none !important;
      }
    }
  }
}
.dragBox {
  background-color: #fff;
  padding: 6px 16px 0 16px;
  margin-bottom: 17px;
}
.conItemBox {
  height: 42px;
  line-height: 25px;
  padding: 12px 31px;
  border-top: 1px solid #dddd;
  text-align: left;
  font-size: 14px;
  color: #999999;
  margin-top: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}

.flexcheck {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  .checktit {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    /deep/.van-checkbox__label {
      max-width: 260px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .dragimg {
    img {
      width: 16px;
      height: 16px;
    }
    .sub-colr {
      margin-right: 15px;
      width: 18px;
      height: 18px;
    }
  }
}
.fixbox {
  span {
    display: inline-block;
    margin-left: 15px;
  }
  .sub_col {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }
}
</style>
